import axios from '@/assets/utils/axios'

export function getList(params) {
  return axios.post('/en/teacher/user/list ', params)
}
export function getUserList(params) {
  return axios.post('/en/teacher/user/list ', params)
}
export function getWorkList(params) {
  return axios.post('/en/teacher/work/list', params)
}
export function getInfo(params) {
  return axios.post('/en/teacher/work/info', params)
}
